<template>
  <div class="content animate-panel" id="content">
    <h2 class="m-n">プレミアム</h2>
    <div class="hpanel">
      <nav-tabs :data="data" :currentTab="tab" />
      <tab-content :data="data" :currentTab="tab" />
    </div>
  </div>
</template>
<script>
import Premiumservice from '../../services/premiumservice'
import NavTabs from './components/NavTabs.vue'
import TabContent from './components/TabContent.vue'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    NavTabs,
    TabContent
  },
  data () {
    return {
      loader: null,
      data: [],
      tab: null
    }
  },
  computed: {
    isBasicPlan () {
      return this.$store.getters.getUser.memberPlan === '0'
    }
  },
  created () {
    if (this.isBasicPlan) {
      this.$router.push('/not-found')
      return false
    }
    this.getData()
  },
  methods: {
    async getData () {
      this.loader = this.$loading.show()
      await Premiumservice.getAll()
        .then((response) => {
          this.data = response.data
          if (this.data.length) {
            const currentTab = this.$route.params.tab
            const validTabIds = this.data.map(item => String(item.id))
            if (!currentTab || !validTabIds.includes(currentTab)) {
              const firstTabId = this.data[0].id
              if (firstTabId) {
                this.$router.replace({
                  name: 'Premium',
                  params: {
                    tab: firstTabId
                  }
                })
              }
            } else {
              this.tab = Number(currentTab)
            }
          }
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    }
  },
  watch: {
    $route (to) {
      const toTab = to.params.tab
      this.tab = toTab
      if (this.tab) {
        let logParams = {
          name: eventCode.premium.show,
          properties: {
            id: this.tab
          }
        }
        EventService.postTrackLog(logParams)
      }
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/premium/Premium.vue